<template>
  <div class="response_table hide_for_print" v-if="status_history.length > 0">
    <label>{{ translate('client_order.order_statuses') }}</label>
    <table>
      <thead style="height: 50px; flex:0; display: inline-block">
        <tr>
          <th scope="col">
            {{ translate('client_order.old_status') }}
          </th>
          <th scope="col">
            {{ translate('client_order.new_status') }}
          </th>
          <th class="pointer" @click="change_filter('user')" :class="{ selected: filter_type === 'user' }"
            scope="col">
            {{ translate('client_order.snapshot_user_name') }}
            <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
          </th>
          <th class="pointer" @click="change_filter('ts')" :class="{ selected: filter_type === 'ts' }"
            scope="col">
            {{ translate('client_order.snapshot_created') }}
            <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
          </th>
          <th scope="col">
            {{ translate('client_order.comments.title') }}
          </th>

        </tr>
      </thead>
      <tbody>
        <tr v-for="(element, key) in status_history" :key="key" class="status_item">
          <td :data-label="translate('client_order.old_status')">
            <span class="badge" :style="'background-color: ' + get_status(element.old_status).color">
              {{ translate("client_order.statuses." + get_status(element.old_status).title) }}
            </span>
          </td>
          <td :data-label="translate('client_order.new_status')">
            <span class="badge" :style="'background-color: ' + get_status(element.status).color">
              {{ translate("client_order.statuses." + get_status(element.status).title) }}
            </span>
          </td>
          <td :data-label="translate('client_order.snapshot_user_name')">
            {{ element.user_name }}
          </td>
          <td :data-label="translate('client_order.snapshot_created')">
            {{ get_date(element.ts_update) }}
          </td>
          <td :data-label="translate('client_order.comments.title')">
            {{ element.comments }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  name: 'ClientOrderOrderStatuses',

  props: {
    client_order_info: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      filter_asc: "asc",
      filter_type: ""
    }
  },

  computed:{
    status_history() {
      let status_history = [...this.client_order_info.status_history];
      return status_history.sort(this.compareNumbers);
    }
  },

  methods: {
    get_status(status) {
      let result = this.$store.getters.getClientOrdersInfo.statuses.find((entry) => {
        if (entry.id === status) {
          return entry
        }
      })
      return result ? result : { title: "Error", color: "red" }
    },
  }
}

</script>

<style lang='scss' scoped>
  .response_table {
    height: auto;
    padding: 0;
    margin-bottom: 20px;

    .header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .mdi{
        font-size: 10px;
        padding: 0;
      }
    }



    .status {
      width: 8%;
    }

    .tariffication {
      width: 20%;
    }

    .tariffication_on {
      background-color: #41b88370;
    }

    .tariffication_off {
      background-color: #ff000057;
    }

    .no_tariffication {
      background-color: transparent;
    }

    table {
      tbody {
        .online {
          color: #15ab00;
        }

        span.badge {
          font-size: 12px;
        }

        span {
          font-size: 20px;
        }
      }

      td {
        padding: 5px;
        p{
          margin: 0;
          font-size: 10px;
        }
        &.bad_sku{
          background-color: #ff000057;
        }
      }
    }
    .w70{
      width: 70px;
    }
    .w30{
      width: 30px;
    }
  }

</style>
